<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs pos-relative"
	style="min-height: 9em;"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet o-block u-width-100p _u-width-100p stats-container">
		<div class="o-stack__cell">
			<h5 *ngIf="graphData.length" class="title primary-color">
				Calls
				<a
					href="javascript:void(0)"
					class="download-icon"
					*ngIf="downloadConfiguration && downloadConfiguration.enableDownload && hasData"
					(click)="downloadCSV()"
					target="_blank"
					><img src="../../../../../assets/images/Download_Icon.svg"
				/></a>
			</h5>
			<h5 *ngIf="!graphData.length" class="title primary-color">Calls</h5>
		</div>
	</div>
	<div class="card3 creative-div">
		<div class="analytics-portlet-content" *ngIf="hasData">
			<div class="sem-div">
				<div class="calls-div" *ngIf="graphData.length">
					<div class="graph-title">
						Number of Answered and Missed Calls
						<div class="filterLabel" [ngClass]="{ 'answered-inactive': dropdownDisabled }">Filter Answered Calls:</div>
						<div style="width: 140px; height: 40px; border-radius: 4px; display: inline-block;">
							<ng-select
								class="dropdown"
								[ngClass]="{ 'answered-inactive': dropdownDisabled }"
								[disabled]="dropdownDisabled"
								[items]="dropdownValues"
								bindLabel="name"
								[(ngModel)]="selectedValues"
								(change)="dropdownChange($event)"
							>
							</ng-select>
						</div>
						<div class="dateRange">
							{{ dateRange }}
						</div>
					</div>

					<div id="chart" #graphArea></div>
					<table class="metrics-div">
						<tr>
							<td>Total Number of Answered Calls</td>
							<td class="metric-value">{{ callsRecieved | number }}</td>
						</tr>
						<tr>
							<td>Total Number of Missed Calls</td>
							<td class="metric-value">{{ callsMissed | number }}</td>
						</tr>
						<tr>
							<td>Avg. Duration (HH:MM:SS)</td>
							<td class="metric-value">{{ avgDuration }}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>

		<div class="no-data-container" *ngIf="!hasData">
			<div class="c-portlet o-block u-width-100p _u-width-100p stats-container">
				<div class="o-stack__cell">
					<h5 class="calls-title primary-color">{{ sectiontitle }}</h5>
				</div>
			</div>
			<div class="map-no-data c-portlet" style="top: 76%; left: 60px;">No data found</div>
		</div>
	</div>
</div>
